class Monitoring.Models.TaggingRule extends Backbone.Model
  urlRoot: '/monitoring/tagging_rules'

  defaults:
    name: ''
    primary_keywords: []
    secondary_keywords: []
    excluded_keywords: []
    primary_keywords_logic: 'OR'
    secondary_keywords_logic: 'OR'
    excluded_keywords_logic: 'OR'
    topics: []
    tag: ''
    sentiment: 'nil'

  validateFields: ->
    "VALID"

  getTopicIdsAsIntegers: ->
    _.map(@get('topics'), (topic) -> parseInt(topic.id))

  getTopicNames: ->
    _.map(@get('topics'), (topic) -> topic.name)

  getSentimentDescription: ->
    return 'no sentiment' if @get('sentiment') == 'nil'
    return 'negative'     if parseInt(@get('sentiment')) == -20
    return 'neutral'      if parseInt(@get('sentiment')) == 0
    return 'positive'     if parseInt(@get('sentiment')) == 20
    '(sentiment error)'


class Monitoring.Collections.TaggingRulesCollection extends Backbone.Collection
  model: Monitoring.Models.TaggingRule
